import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/NotFoundPage.css';

const NotFoundPage = () => {
  const { pathname } = useLocation();

  return (
    <div className="not-found-page" id="page-not-found">
      <h1 className="not-found-title">Page Not Found</h1>
      <p className="not-found-message" id="not-found-message">
        The page <strong>{pathname}</strong> does not exist. Please check the URL or use the
        sidebar to open a valid practice page.
      </p>
      <Link to="/" className="not-found-home-link" id="not-found-home-link">
        Go to Home
      </Link>
    </div>
  );
};

export default NotFoundPage;
